import GroupPermissionHeaderTitle from './GroupPermissionHeaderTitle'
export default GroupPermissionHeaderTitle
